module.exports = __webpack_public_path__ + "static/thirty-1-927a9910f371fe6500d5ddc8fcc25530.png";